<template>
  <div v-if="show">
    <h2 class="mt_20 mb_5">Shifts key</h2>
    <table class="table table-striped">
      <thead>
        <tr>
          <th>Key</th>
          <th>Shift descriptions</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="shift in shifts" :key="shift.id">
          <td>
            <span :style="{ color: shift.color }">{{ shift.key }}</span>
          </td>
          <td>
            {{ shift.name }} ( {{ shift.formatted_start_time }} -
            {{ shift.formatted_end_time }} )
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>
<script>
export default {
  name: 'ShiftTableComponent',
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    shifts: {
      type: Array,
      default: () => [],
    },
  },
};
</script>
